export default __webpack_public_path__ + "static/media/checkLevelUpMenu.b8439f88.png";